import { record, itemField, type Row } from '../ability/context';
import { storedStatusRows } from '../compile/creature-status-reader';
import { statusItemId } from './expiry';

/** The root picture gate follows the held target statuses. Form stats and removal
 * consequences belong to their native producers; this writes only the flag. */
export function projectShapeshiftFlag(row: Row, definition?: (id: string) => Row | null, removedStatusId?: string): string | null {
  let unknown = '';
  for (const status of storedStatusRows(row, 'target')) {
    if (removedStatusId && String(itemField(status, 'status_id') ?? '').toUpperCase() === removedStatusId.toUpperCase()) continue;
    const id = statusItemId(status);
    const catalog = record(row.catalog);
    const held = record(status.status_arr) ?? record(catalog?.[id] ?? catalog?.[id.toLowerCase()]);
    const type = itemField(held, 'item_type') ?? itemField(id ? definition?.(id) ?? null : null, 'item_type');
    if (type === 'creature') {
      if (!itemField(row, 'shapeshifted')) row.shapeshifted = [1];
      return null;
    }
    if (type == null) unknown ||= id || 'unknown';
  }
  // Missing definitions cannot prove that the last form ended. Let the native
  // producer name that missing input rather than clearing a possibly live form.
  if (unknown) return `status-shapeshift:definition-not-held:${unknown}`;
  delete row.shapeshifted;
  return null;
}
